(ns rothko.header.component
  (:require [rothko.button.component :refer [button]]
            [rothko.component.core :refer [defcomp]]
            [rothko.css.inline :refer [declarations->class
                                       cond-declarations->class]]
            [rothko.header.styles :as styles]
            [rothko.header.spec :as spec]
            [rothko.logo.component :refer [logo]]
            [rothko.icon.component :refer [icon]]))

(defcomp header-logo
  {:spec ::spec/header-logo}
  [{:keys [dev-mode? dev-mode-text logo-description logo-name logo-title logo-width appearance] :as props} & children]
  (if dev-mode?
    [:span dev-mode-text]
    [:h2.header-title
     [logo {:desc logo-description
            :logo-name logo-name
            :title logo-title
            :width logo-width}]]))

(defcomp sign-in-out-button
  {:spec ::spec/sign-in-out-button}
  [{:keys [logged-in? login-path sign-in-text sign-in-visible? sign-out-handler sign-out-text]} & children]
  (when sign-in-visible?
    (if logged-in?
      [:a#logout-btn.login-btn {:on-click sign-out-handler}
       [:div.icon-container
        [icon {:icon :sign-out
               :size 16}]
        [:span sign-out-text]]]
      [:a#login-btn.login-btn {:href login-path}
       [:div.icon-container
        [icon {:icon :sign-in
               :size 16}]
        [:span sign-in-text]]])))

(defn hamburger-menu-button
  [{:keys [burger-bun-width cross-width menu-open? menu-toggle-handler]}]
  [button {:appearance #{:invisible}
           :on-click menu-toggle-handler
           :class [:hamburger-menu-button]}
   [:div.hamburger-menu-icon-container
    {:style {:width 20
             :height 20}}
    [:div.burger-icon-container
     {:class (cond-declarations->class
              styles/menu-icon-container
              menu-open? styles/menu-icon-bars--hidden)}
     [icon {:icon :bars
            :size burger-bun-width
            :class (declarations->class styles/menu-icon)}]]
    [:div.cross-icon-container
     {:class (cond-declarations->class
              styles/menu-icon-container
              (not menu-open?) styles/menu-icon-cross--hidden)}
     [icon {:icon :cross
            :size cross-width
            :class (declarations->class styles/menu-icon)}]]]])

(defcomp main
  [{:keys [appearance class left-container menu-open? right-container side-nav style]}
   & children]
  (into [:header {:class (concat class appearance)
                  :style style}
         [:div {:style {:display :flex :width "100%"}}
          (into [:div.header-left-container]
                left-container)
          [:div.header-right-container
           (into [:div.header-right-container-inner]
                 right-container)]
          (when side-nav
            (into [:div.header-side-nav {:class (when menu-open? [:open])}]
                  side-nav))]]
        children))
